import React from 'react'
import { 
  Avatar, 
  Card, 
  Grid, 
  Typography, 
  useTheme 
} from '@mui/material'
import useCurrentUserInfo from '../../../hooks/useCurrentUserInfo';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import AddLinkOutlinedIcon from '@mui/icons-material/AddLinkOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { useNavigate } from 'react-router-dom';
import useIsMobile from '../../../hooks/useIsMobile';

function ProfileInfoControl() {

  const theme = useTheme();
  const mobile = useIsMobile();
  const userInfo = useCurrentUserInfo();
  const navigate = useNavigate();

  return (
    <Grid sx={{ width: '100%', display: 'flex', flexDirection: 'column'}}>
      <Grid 
        item 
        display={'flex'} 
        justifyContent={'center'} 
        alignItems={'center'}
        flexDirection={'column'}
        width={'100%'}
        height={'12rem'}
        sx={{
          backgroundColor: `${theme.palette.primary.main}`,
          borderBottomLeftRadius: '2rem',
          borderBottomRightRadius: '2rem'
        }}
      > 
        <Avatar 
          alt={userInfo?.name?.split('')[0]} 
          src={userInfo?.picture ?? 'https://res.cloudinary.com/djrbfvpit/image/upload/v1737325651/CloudSous%20Assets/saaschowlogo2_xf1j79.png'} 
          sx={{ 
            width: '6rem', 
            height: '6rem',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            border: `1px solid ${theme.palette.grays.main}`
          }}
        />
        <Typography variant='h5' color={`${theme.palette.whites.main}`}>
          { userInfo?.username }
        </Typography>
        <Typography variant='body2' color={'secondary'}>
          { userInfo?.email }
        </Typography>
      </Grid>
      <Grid 
        item 
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          marginTop: '2rem',
          alignItems: 'center', // Change from 'center' to prevent centering content
          width: '100%',
          flexGrow: 1, // Add this
          overflow: 'auto', // Change from 'scroll' to 'auto'
          flexDirection: 'column',
          maxHeight: mobile ? '75dvh' : '65dvh',
          '&::-webkit-scrollbar': {
            width: '0.4em'
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent'
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(0,0,0,.1)',
            borderRadius: '24px'
          }
        }}
      >
        <Card 
          sx={{ 
            width: '85%', 
            height: '4rem', 
            marginBottom: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '1rem'
          }}
          onClick={() => navigate('/edit-profile-info')}
        >
          <Grid 
            item 
            display={'flex'} 
            justifyContent={'flex-start'} 
            alignItems={'center'}
          >
            <BorderColorOutlinedIcon 
              sx={{
                margin: '1rem', 
                color: `${theme.palette.grays.dk}`
              }}
            />
            <Typography sx={{ color: `${theme.palette.grays.dk}`}}>
              Edit Profile Info
            </Typography>
          </Grid>
          <Grid item display={'flex'} justifyContent={'flex-end'}>
            <ChevronRightOutlinedIcon 
              sx={{
                margin: '1rem', 
                color: `${theme.palette.grays.main}`,
                fontSize: '2rem'
              }}
            />
          </Grid>
        </Card>
        <Card 
          sx={{ 
            width: '85%', 
            height: '4rem', 
            marginBottom: '2rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '1rem'
          }}
          onClick={() => navigate('/chef-page-preview')}
        >
          <Grid 
            item 
            display={'flex'} 
            justifyContent={'flex-start'} 
            alignItems={'center'}
          >
            <VisibilityOutlinedIcon 
              sx={{
                margin: '1rem', 
                color: `${theme.palette.grays.dk}`
              }}
            />
            <Typography sx={{ color: `${theme.palette.grays.dk}`}}>
              Preview Chef Page
            </Typography>
          </Grid>
          <Grid item display={'flex'} justifyContent={'flex-end'}>
            <ChevronRightOutlinedIcon 
              sx={{
                margin: '1rem', 
                color: `${theme.palette.grays.main}`,
                fontSize: '2rem'
              }}
            />
          </Grid>
        </Card>
        {/* <Card 
          sx={{ 
            width: '85%', 
            height: '4rem', 
            marginBottom: '1rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '1rem'
          }}
        >
          <Grid 
            item 
            display={'flex'} 
            justifyContent={'flex-start'} 
            alignItems={'center'}
          >
            <DeleteForeverOutlinedIcon 
              sx={{
                margin: '1rem', 
                color: 'red',
                fontSize: '2rem'
              }}
            />
            <Typography sx={{ color: 'red'}}>
              Delete Profile
            </Typography>
          </Grid>
          <Grid item display={'flex'} justifyContent={'flex-end'}>
            <ChevronRightOutlinedIcon 
              sx={{
                margin: '1rem', 
                color: `${theme.palette.grays.main}`
              }}
            />
          </Grid>
        </Card> */}

      </Grid>
    </Grid>
  )
}

export default ProfileInfoControl;